/**
 * WarrantyChatTour — 3-step on-ramp for /warranty/claims/{cid}/chat.
 */
import TourOverlay from "@/components/TourOverlay";

const STEPS = [
  {
    id: "messages",
    selector: '[data-testid="warranty-chat-messages"]',
    placement: "right",
    title: "Real-time messages",
    body: "Every message arrives within ~1 second via Server-Sent Events — no polling delay. System bubbles capture the wizard transcript, AI bubbles surface close-case offers, and file attachments back-link automatically into the claim's media list.",
    optional: true,
  },
  {
    id: "ai-suggest",
    selector: '[data-testid="warranty-chat-ai-suggest"]',
    placement: "below",
    title: "Ask AI: should we close?",
    body: "Staff only. Runs Claude over the full transcript and posts a close-offer message if it thinks the case is resolved. The customer sees the offer; an admin still has to click Close case to finalize.",
    optional: true,
  },
  {
    id: "close",
    selector: '[data-testid="warranty-chat-close-btn"]',
    placement: "below-end",
    title: "Close case",
    body: "Gated on the can_close_warranty_case permission (or super-admin). Marks the claim closed, appends the reason to status_history, audit-logs the action, and seals the chat.",
    optional: true,
  },
  {
    id: "done",
    selector: null,
    placement: "center",
    title: "You're set.",
    body: "Drag a file onto the composer or click the paperclip to attach — files appear in BOTH the chat and the claim's media list. .exe / .bat and other executables are blocked. Reset this tour: localStorage.removeItem('warranty_chat_tour_seen_v1').",
  },
];

export default function WarrantyChatTour() {
  return (
    <TourOverlay
      storageKey="warranty_chat_tour_seen_v1"
      bannerTitle="First time in Warranty Chat?"
      bannerCopy="Take the 30-second tour — real-time messages, AI close suggest, and the close-case button in 3 steps."
      bannerTone="violet"
      testIdPrefix="warranty-chat-tour"
      steps={STEPS}
    />
  );
}
